import { schema } from 'normalizr';

const entitySchema = new schema.Entity('instruction', undefined, { idAttribute: 'id' });

export default entitySchema;
